import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import "./registerServiceWorker";

import VueMaterial from "vue-material";
import "vue-material/dist/vue-material.min.css";
import VueResource from "vue-resource";
import VueMask from "v-mask";
import VueSession from "vue-session";
import sha1 from "js-sha1";
import md5 from "blueimp-md5";
import VuePageTransition from "vue-page-transition";
import moment from "moment";
import "moment/locale/es";
import estados from "./assets/data/estados.json";
import municipios from "./assets/data/municipios.json";
import CKEditor from "@ckeditor/ckeditor5-vue";
import VueOffline from "vue-offline";
import exportFromJSON from "export-from-json";

Vue.use(VueOffline);
Vue.use(CKEditor);
Vue.use(VuePageTransition);
Vue.use(VueSession, {
	persist: true
});
Vue.use(VueResource);
Vue.use(VueMaterial);
Vue.use(VueMask);

//Vue.http.options.root = "http://localhost/fc/fundacion-cima/api";
Vue.http.options.root = "http://terakamel.com/fundacion-cima/api/"

Vue.http.options.emulateJSON = true;
Vue.prototype.$showDialogSync = false;
Vue.prototype.$syncInfo = "Sincronice por favor. Es necesario descargar datos.";
Vue.prototype.$no_internet = "Verifique su conexión a internet.";
Vue.prototype.$llene_campos = "Llene los campos indicados con *";
Vue.prototype.$obligatorio = "Llene este campo";
Vue.prototype.$headers = {
	headers: {
		Token: null
	}
};

Vue.prototype.$estados = estados.estados;
Vue.prototype.$municipios = municipios.municipios;

Vue.prototype.$nF = n => {
	return Intl.NumberFormat("es-MX", {
		style: "currency",
		currency: "MXN"
	}).format(n);
};
Vue.prototype.$moment = (a, b) => {
	return moment(a, b);
};
Vue.prototype.$mdError = a => {
	return a ? null : "md-invalid";
};
Vue.prototype.$validate = arr => {
	return Object.values(arr).indexOf("md-invalid") <= -1 ? true : false;
};
Vue.prototype.$enc = a => {
	return sha1(md5(a));
};
Vue.prototype.$doCSV = (data, fileName) => {
	const exportType = "csv";
	exportFromJSON({
		data,
		fileName,
		exportType
	});
};

Vue.config.productionTip = false;

new Vue({
	router,
	render: h => h(App)
}).$mount("#app");